import { USER_LOGIN_DATA, USER_LOGIN_ERROR, USER_LOGOUT, FILTER_PROCEDURE_CODE } from '../../../actions'

const initialState = {
  role: '',
  user: '',
  name: '',
  authErrorMessage: '',
  isAppConfigSuccessful: false,
}

export const addUserLoginData = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_DATA:
      return { ...state, ...action.payload }
    case USER_LOGIN_ERROR:
      return { ...state, authErrorMessage: action.errorMessage, isAppConfigSuccessful: action.isAppConfigSuccessful }

    case USER_LOGOUT:
      return initialState

    default:
      return state
  }
}

export const addFilterProcedureCodeData = (state = {}, action) => {
  switch (action.type) {
    case FILTER_PROCEDURE_CODE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
